import { breakpoints } from '../../../constants';
import { eventThrottle } from '../../../utility';
import triggerWindowResize from '../../../utility/triggerWindowResize';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 4,
  peek: 16,
  rewind: false,
  bound: true,
  gap: 16,
  breakpoints: {
    525: {
      perView: 1,
    },
    [breakpoints['break-1']]: {
      perView: 2,
    },
    [breakpoints['break-2']]: {
      perView: 3,
    },
  },
};

const selectors = {
  sliderSelector: '[data-events-callout-slider="slider"]',
  slideSelector: '[data-events-callout-slider="slide"]',
  sliderHeader: '[data-events-callout-slider="header"]',
  sliderHeaderHiddenClass: 'events-callout-slider__header--hidden',
  leftArrowSelector: '[data-events-callout-slider="arrow-left"]',
  rightArrowSelector: '[data-events-callout-slider="arrow-right"]',
};

export default class eventsCalloutSlider {
  constructor(el) {
    this.el = el;
    this.sliderEl = this.el.querySelector(selectors.sliderSelector);
    this.sliderHeader = this.el.querySelector(selectors.sliderHeader);
    this.leftArrowBtnEl = this.el.querySelector(selectors.leftArrowSelector);
    this.rightArrowBtnEl = this.el.querySelector(selectors.rightArrowSelector);
    this.initSlider();
    this.addSlideChangeListener();
    triggerWindowResize();
    this.handleArrowButtonVisibility();
    window.addEventListener('resize', eventThrottle(() => this.handleSlider(), 200));
  }

  initSlider() {
    this.eventsCalloutSlider = new GlideSlider(
      this.sliderEl,
      glideOptions,
      selectors,
    );

    this.eventsCalloutSliderGlideInstance = this.eventsCalloutSlider.getGlideSlider();
    this.eventsCalloutSliderGlideInstance.mount();
  }

  addSlideChangeListener() {
    this.eventsCalloutSliderGlideInstance.on('run', () => {
      this.hideHeaderContent();
      this.handleArrowButtonVisibility();
    });
  }

  hideHeaderContent() {
    if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
      if (this.eventsCalloutSliderGlideInstance.index !== 0 && !this.sliderHeader.classList.contains(selectors.sliderHeaderHiddenClass)) {
        this.sliderHeader.classList.add(selectors.sliderHeaderHiddenClass);
      } else if (this.eventsCalloutSliderGlideInstance.index === 0 && this.sliderHeader.classList.contains(selectors.sliderHeaderHiddenClass)) {
        this.sliderHeader.classList.remove(selectors.sliderHeaderHiddenClass);
      }
    }
  }

  handleArrowButtonVisibility() {
    if (this.eventsCalloutSliderGlideInstance.index === 0) {
      this.leftArrowBtnEl.style.display = 'none';
    } else {
      this.leftArrowBtnEl.style.display = 'flex';
    }

    let perView = 2;
    if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
      perView = 4;
    } else if (window.matchMedia(`(min-width: ${breakpoints['break-1']}px)`).matches) {
      perView = 4;
    } else if (window.matchMedia('(min-width: 525px)').matches) { // Make sure this matches the breakpoint in glideOptions
      perView = 3;
    }

    if (this.eventsCalloutSliderGlideInstance.index >= this.eventsCalloutSlider.getNumberOfSlides() - perView) {
      this.rightArrowBtnEl.style.display = 'none';
    } else {
      this.rightArrowBtnEl.style.display = 'flex';
    }
  }

  handleSlider() {
    this.hideHeaderContent();
    this.handleArrowButtonVisibility();
  }
}
